import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import LineChart from '../../charts/LineChart01';
import Icon from '../../images/icon-01.svg';
import EditMenu from '../EditMenu';

// Import utilities
import { tailwindConfig, hexToRGB } from '../../utils/Utils';
import HubSpotIcon from '../../images/hubspot.png'
import IntercomIcon from '../../images/intercom.png'

function IntegrationOverviewCard01({overview, selectedTab}) {

  const [chartData, setChartData] = useState({})

  useEffect(() => {
    if(overview.activeIntegration.insightJobPending===false){
      var campaigns = []
      for (var i = 0; i < overview.prevOpened.length; i++) {
        campaigns.push(i);
      }

      setChartData({
        labels: campaigns,
        datasets: [
          // Indigo line
          {
            data: overview.prevOpened,
            fill: true,
            backgroundColor: `rgba(${hexToRGB(tailwindConfig().theme.colors.green[500])}, 0.3)`,
            borderColor: tailwindConfig().theme.colors.green[500],
            borderWidth: 2,
            tension: 0,
            pointRadius: 0,
            pointHoverRadius: 3,
            pointBackgroundColor: tailwindConfig().theme.colors.green[500],
            clip: 20,
          },
          // Gray line
          {
            data: overview.prevDelivered,
            fill: true,
            backgroundColor: `rgba(${hexToRGB(tailwindConfig().theme.colors.indigo[500])}, 0.08)`,
            borderColor: tailwindConfig().theme.colors.indigo[500],
            borderWidth: 2,
            tension: 0,
            pointRadius: 0,
            pointHoverRadius: 3,
            pointBackgroundColor: tailwindConfig().theme.colors.indigo[500],
            clip: 20,
          },
        ],
      })
    }
  }, [overview]);

  function handleIcon (overview) {
    switch (overview.name) {
      case 'HubSpot':
        return (
          <img className="rounded-full bg-white cursor-pointer" src={HubSpotIcon} width="36" height="36"
               onClick={()=>selectedTab(overview.name, overview.activeIntegration)} />
        );
      case 'Intercom':
        return (
          <img className="rounded-full bg-white cursor-pointer" src={IntercomIcon} width="36" height="36"
               onClick={()=>selectedTab(overview.name, overview.activeIntegration)} />
        );
      default:
        return (
          <svg className="flex-shrink-0 mr-2 sm:mr-3" width="36" height="36" viewBox="0 0 36 36">
            <circle fill="#24292E" cx="18" cy="18" r="18" />
            <path d="M18 10.2c-4.4 0-8 3.6-8 8 0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4V24c-2.2.5-2.7-1-2.7-1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.3 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6-.2 1.3-.3 2-.3s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.4.6.9.6 1.6v2.2c0 .2.1.5.6.4 3.2-1.1 5.5-4.1 5.5-7.6-.1-4.4-3.7-8-8.1-8z" fill="#FFF" />
          </svg>
        );
    }
  }



  function cleanOverviewTime(updatedOn){
    return updatedOn.split('T')[0] + ' ' + updatedOn.split('T')[1].split('.')[0]
  }

  return (
    <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-1 rounded-sm border border-gray-200">
      <div className="px-5 pt-5 text-ce">
        <header className="flex items-center justify-between mb-4">
          {/* Icon */}
          {handleIcon(overview)}
          {/* Menu button */}
          <h2 className="text-2xl align-middle font-semibold text-gray-800 cursor-pointer" onClick={()=>selectedTab(overview.name, overview.activeIntegration)}>{overview.name}</h2>
          <EditMenu className="relative inline-flex float-right">
            <li key="1">
              <button className="font-medium text-sm text-gray-600 hover:text-gray-800 flex py-1 px-3" onClick={()=>selectedTab(overview.name, overview.activeIntegration)}>More Detail</button>
            </li>
            <li key="2">
              <button className="font-medium text-sm text-red-500 hover:text-red-600 flex py-1 px-3" onClick={()=>selectedTab('add', null)}>Disconnect</button>
            </li>
          </EditMenu>
        </header>
        <div className="flex justify-between">
          <div>
            <div className="text-xs font-semibold text-gray-400 uppercase mb-1"># Campaigns</div>
            <div className="flex items-start mb-2">
              <div className="text-3xl font-bold text-gray-800 w-full text-center">{overview.activeIntegration.insightJobPending===true?'⌛':
                  overview.numcampaigns}</div>
            </div>
          </div>
          <div>
            <div className="text-xs font-semibold text-gray-400 uppercase mb-1"># Emails Sent</div>
            <div className="flex items-start">
              <div className="text-3xl font-bold text-gray-800 w-full text-center">{overview.activeIntegration.insightJobPending===true?'⌛':
                  overview.numsent>=1000000?Math.round(overview.numsent/1000000)+'M+':overview.numsent}</div>
              {/*<div className="text-sm font-semibold text-white px-1.5 bg-green-500 rounded-full">{(overview.avgOpen * 100).toFixed(1)}% Avg. Open Rate</div>*/}
            </div>
          </div>
          <div>
            <div className="text-xs font-semibold text-gray-400 uppercase mb-1">Avg. Open Rate</div>
            <div className="flex items-start">
              <div className="text-3xl font-bold text-gray-800 w-full text-center">{overview.activeIntegration.insightJobPending===true?'⌛':
                  (overview.avgopen).toFixed(1)+'%'}</div>
              {/*<div className="text-sm font-semibold text-white px-1.5 bg-green-500 rounded-full">{(overview.avgOpen * 100).toFixed(1)}% Avg. Open Rate</div>*/}
            </div>
          </div>
        </div>

      </div>
      {/* Chart built with Chart.js 3 */}
      <div className="flex-grow">
        {/* Change the height attribute to adjust the chart height */}
        <LineChart data={chartData} width={389} height={128} />
      </div>
      <div className="flex items-center justify-between px-5 pb-3 text-xs">
        {/* Left side */}
        <div>
          {overview.activeIntegration.insightJobPending?
            <div className="flex items-center text-gray-400 hover:text-indigo-500">
              <div className=" text-gray-500">⏳ Calculating Insights</div>
            </div>:<div className="flex items-center text-gray-400 hover:text-indigo-500">
              <div className=" text-gray-500">✅ Insights Ready</div>
            </div>}
        </div>
        {/* Right side */}
        <div className="flex items-center">
          <strong className="mr-1">Updated:</strong> {cleanOverviewTime(overview.activeIntegration.updatedOn)}
        </div>
      </div>
    </div>
  );
}

export default IntegrationOverviewCard01;
